import { API_BASE_URL } from 'src/env';
import { ApiReturnType } from 'src/interfaces/api/api';
import DeliveryOrder, { PostDeliveryOrderBody } from 'src/interfaces/api/DeliveryOrder';
import { Order } from 'src/interfaces/Table';
import { toQueryParamsString } from 'src/utils/ApiUtils';

export default {
  get: (id: DeliveryOrder['id']): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/delivery-order/delivery-orders/${id}`,
    method: 'GET',
  }),
  getAll: (searchCriteria: object, orderBy: string, order: Order = 'asc', page = 1, limit = 10): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/delivery-order/delivery-orders${toQueryParamsString({
      ...searchCriteria,
      page,
      limit,
      orderBy,
      order,
    })}`,
    method: 'GET',
  }),
  create: (data: PostDeliveryOrderBody & { token?: string }, fromProvider: boolean): ApiReturnType => {
    const params = new FormData();

    data.attachments.forEach((attachment) => {
      params.append('attachments[]', attachment);
    });

    data.attachments = [];

    Object.keys(data).forEach((key) => {
      if (data[key]) {
        if ('articles' === key) {
          params.append(key, JSON.stringify(data[key]));
        } else {
          params.append(key, data[key]);
        }
      }
    });

    return {
      endpoint: `${API_BASE_URL}/v2/delivery-order/delivery-orders${fromProvider ? '/external' : ''}`,
      body: params,
      method: 'POST',
    };
  },
  update: (id: string, data: PostDeliveryOrderBody): ApiReturnType => {
    const params = new FormData();

    data.attachments.forEach((attachment) => {
      params.append('attachments[]', attachment);
    });

    data.attachments = [];

    Object.keys(data).forEach((key) => {
      if (data[key]) {
        if ('articles' === key) {
          params.append(key, JSON.stringify(data[key]));
        } else {
          params.append(key, data[key]);
        }
      }
    });

    return {
      endpoint: `${API_BASE_URL}/v2/delivery-order/delivery-orders/${id}`,
      body: params,
      method: 'POST',
    };
  },
  getAttachment: (deliveryOrderId: DeliveryOrder['id'], attachmentId: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/delivery-order/delivery-orders/${deliveryOrderId}/attachments/${attachmentId}`,
  }),
};
